export default __webpack_public_path__ + "static/media/ardashirfort.1e51d204.jpg";